/**
 * @generated SignedSource<<aabbf8e2e3223910920ccca1d238ca81>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButtons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_viewer" | "PdpSharedBuyItNowButton_viewer">;
  readonly " $fragmentType": "PdpSharedShoppingButtons_viewer";
};
export type PdpSharedShoppingButtons_viewer$key = {
  readonly " $data"?: PdpSharedShoppingButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButtons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAddToCartButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4936ca0962661fe5d3167eb01e56bac1";

export default node;
